import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';
import { resolveAstralIconClass } from '../astral-icon-class.util';

@Component({
  selector: 'astral-image-preview',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    @if (!failed) {
    <img
      class="astral-image-preview__image"
      [src]="displaySrc"
      [alt]="alt"
      [style.object-fit]="objectFit"
      (error)="failed = true"
    />
    } @else {
    <span class="astral-image-preview__fallback" role="img" [attr.aria-label]="fallbackTextKey | translate">
      <i [class]="imageBrokenIconClass" aria-hidden="true"></i>
      <span>{{ fallbackTextKey | translate }}</span>
    </span>
    }
  `,
  styleUrls: ['./astral-image-preview.component.scss'],
})
export class AstralImagePreviewComponent implements OnChanges, OnDestroy {
  @Input() src: string | Blob | SafeUrl | null | undefined;
  @Input() alt = '';
  @Input() objectFit: 'contain' | 'cover' = 'contain';
  @Input() fallbackTextKey = 'COMMON.IMAGE_LOAD_FAILED';

  failed = false;
  displaySrc: string | SafeUrl = '';
  private objectUrl: string | null = null;

  get imageBrokenIconClass(): string {
    return resolveAstralIconClass('imageBroken') ?? '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) {
      this.failed = false;
      this.revokeObjectUrl();
      if (this.src instanceof Blob) {
        this.objectUrl = URL.createObjectURL(this.src);
        this.displaySrc = this.objectUrl;
      } else {
        this.displaySrc = this.src ?? '';
      }
    }
  }

  ngOnDestroy(): void {
    this.revokeObjectUrl();
  }

  private revokeObjectUrl(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }

  }
}
